/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HomeMatch = {
    properties: {
        leagueTournamentName: {
            type: 'Translation',
            isRequired: true,
        },
        leagueTournamentId: {
            type: 'number',
            isRequired: true,
        },
        leagueTournamentType: {
            type: 'MatchType',
            isRequired: true,
        },
        matches: {
            type: 'array',
            contains: {
                type: 'MatchSmall',
            },
            isRequired: true,
        },
    },
} as const;
